module.exports = "query GetDrafts($offset: Int!, $limit: Int!) {\n  drafts(offset: $offset, limit: $limit) {\n    ...DraftFragment\n  }\n}\n"